import Objectives from './ObjectivesContainer';

export default Objectives;
